module.exports = __webpack_public_path__ + "img/Chang_Wen_Chen@2x.9d29c3e6.png";